import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateProposalStageFiveCtrl', CreateProposalStageFiveCtrl);

    function CreateProposalStageFiveCtrl($scope, createProposalService) {
        var vm = this;

        vm.submit = submit;

        init();

        function init() {
            vm.ui = {
                submitting: false,
                canSubmit: false,
                canSaveAsDraft: false
            };
            vm.data = createProposalService.getStageFive();
            vm.tsos = {
                tso0: createProposalService.getStageOne().tso0,
                tso1: createProposalService.getStageOne().tso1
            };
            vm.remitReportingSettings =
                createProposalService.getStageOne().remitReportingSettings;
            vm.networkPoint =
                createProposalService.getStageOne().selectedNetworkPoint;
            vm.tsoConfig = createProposalService.getStageOne().tsoConfig;
            vm.intention = createProposalService.getStageTwo().intention;
            vm.hasNegativePrice =
                createProposalService.getStageThree().offer.price.originalValue
                    .value < 0;

            if (!vm.networkPoint.bundled) {
                if (
                    vm.tsoConfig.tso0Config.assignmentState === 'APPROVED' ||
                    (vm.tsoConfig.tso0Config.assignmentState === 'PENDING' &&
                        vm.intention === 'PROPOSAL_TO_SELL')
                ) {
                    vm.ui.canSubmit = true;
                    vm.ui.canSaveAsDraft = true;
                }
                if (
                    vm.tsoConfig.tso0Config.assignmentState === 'PENDING' &&
                    vm.intention === 'PROPOSAL_TO_BUY'
                ) {
                    vm.ui.canSubmit = false;
                    vm.ui.canSaveAsDraft = true;
                }
            } else {
                if (
                    (vm.tsoConfig.tso0Config.assignmentState === 'APPROVED' &&
                        vm.tsoConfig.tso1Config.assignmentState ===
                            'APPROVED') ||
                    (vm.tsoConfig.tso0Config.assignmentState === 'PENDING' &&
                        vm.tsoConfig.tso1Config.assignmentState === 'PENDING' &&
                        vm.intention === 'PROPOSAL_TO_SELL')
                ) {
                    vm.ui.canSubmit = true;
                    vm.ui.canSaveAsDraft = true;
                }
                if (
                    vm.tsoConfig.tso0Config.assignmentState === 'PENDING' &&
                    vm.tsoConfig.tso1Config.assignmentState === 'PENDING' &&
                    vm.intention === 'PROPOSAL_TO_BUY'
                ) {
                    vm.ui.canSubmit = false;
                    vm.ui.canSaveAsDraft = true;
                }
            }
        }

        function submit(isValid, asDraft) {
            if (!isValid) {
                $scope.wizard.goToTop();
                return false;
            }

            if (asDraft) {
                vm.data.action = createProposalService.WIZARD_ACTION.DRAFT;
            } else {
                vm.data.action = createProposalService.WIZARD_ACTION.CREATE;
            }

            vm.ui.submitting = true;

            createProposalService.setStageFive(vm.data);
            var promise = $scope.wizard.finished();
            promise.catch(function (error) {
                vm.ui.submitFailed = true;
                vm.ui.submitFailedMessage =
                    error.data.message || error.data.description;
            });
            promise.finally(function () {
                vm.ui.submitting = false;
            });
        }
    }
})();
